import { environment } from './../../environments/environment';
const domain = environment.apiDomain + '/api/';

export const Doctypes = {
  user_permission: 'User Permission',
  hospitality_unit: 'Hospitality Unit', //"Company"
  roles: 'Role',
  users: 'User',
  roles_permission: 'Roles Permission',
  business_unit: 'Business Unit',
  module_def: 'Module Def',
  WfRoles: 'WF Roles',
  ezy_employee: 'Ezy Employee',
  marsha_code: 'Marsha Code',
  role_module_management: 'Role Module Management',
  suite_items: 'Suite items',
  departments: 'Ezy Departments',
  app_info: 'App Info',
  Social_Login_Key: 'Social Login Key',
  New_Social_Login_Key: 'New Social Login Key',
  ezy_file_extensions: 'Ezy File Extensions',
  wf_roadmap: 'WF Roadmap',
  ezy_rule: 'Ezy Rule',
  ezy_rule_condition: 'Ezy Rule Condition',
};

export const workflowDoctypes = {
  roadmap: 'WF Roadmap',
  WFSettings: 'WF Settings',
  WFModules: 'Module Def',
  WFRole: 'WF Roles',
  WFRoleMatrix: 'WF Role Matrix',
  DocType: 'DocType',
  Role: 'Role',
  User_doc: 'User',
  wf_workflow_requests: 'WF Workflow Requests',
  get_wf_reasons: 'WF Reasons',
  wf_activity_log: 'WF Activity Log',
  wf_supporting_documents: 'WF Supporting Documents',
  marsha_code: 'Marsha Code',
};

export const ChildDoctypes = {
  wf_level_setup: 'WF Level Setup',
  wf_requestors: 'WF Requestors',
  wf_users: 'WF Users',
  permission_list: 'Permission List',
  wf_doctype_and_field: 'WF Doctype And Field',
};

export const ApiUrls = {
  resource: domain + `resource`,
  login: domain + 'method/login',
  logout: domain + 'method/logout',
  uploadFile: domain + `method/upload_file`,
  get_companies_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.companies_list`,
  create_company:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.create_company_in_suite_settings`,
  modules_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.modules_enabled_by_companies`,
  get_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.converting_resource_to_custom`,
  get_by_name:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.get_doc_custom`,
  getting_auth_url: domain + `method/ezy_flow.utils.getting_auth_url`,
  post_resource:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.converting_resource_post_call_to_custom_post_call`,
  put_resource:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.edit_call_resource_doctype`,
  reset_password:
    domain +
    `method/ezy_flow.pwd_management.doctype.routes.routes.reset_initial_password`,
  initial_password:
    domain + `method/ezy_flow.pwd_management.doctype.routes.routes.update_pwd`,
  admin_setting_password:
    domain +
    `method/ezy_flow.pwd_management.doctype.routes.routes.create_users_password_if_user_is_created_in_ezy_emp`,
  check_old_password:
    domain +
    `method/ezy_flow.pwd_management.doctype.routes.routes.change_old_password`,
  users_by_marsha:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.users_list_by_marsha`,
  update_child_table_of_doctype:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.update_child_table_of_doctype`,
  modules_based_on_company:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.modules_based_on_company`,

  //Child Doctype APi Calls..

  put_resource_child_doc:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.update_child_table_of_doctype`,

  post_child_table_of_doctype:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.post_child_table_of_doctype`,
  converting_custom_api_delete_call:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.converting_custom_api_delete_call`,
  getUserPermissionsList:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.user_permissions`,
  check_record_exists:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.check_record_exists`,
  get_module_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.marsha_code.marsha_code.get_module_list`,
  import_ezy_employee_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.ezy_employee.ezy_employee.enqueuing_data_import`,
  ezy_forms_wf_requests:
    domain + `/method/ezy_forms.api.v1.assign_to_me.pick_view_only_reportee`,
  dynamic_accordion_list:
    domain +
    `method/ezy_flow.ezy_flow.doctype.wf_settings.wf_settings.getting_app_name_module_names_for_a_user`,
  roadmap_and_request:
    domain +
    `method/ezy_flow.ezy_flow.doctype.wf_workflow_requests.wf_workflow_requests.combination_of_roadmap_and_request`,
  approvals_requesters:
    domain +
    `method/ezy_flow.ezy_flow.doctype.wf_workflow_requests.wf_workflow_requests.updating_wf_workflow_requests`,
  login_with_username_and_email:
    domain +
    `method/ezy_flow.ezy_flow.doctype.ezy_employee.ezy_employee.login_with_user_and_email`,
  ezyrecon_supporting_document_type_for_ar_billing_and_bonvoy: domain + `method/ezy_flow.ezy_flow.doctype.suite_items.suite_items.ezyrecon_supporting_document_type_for_ar_billing_and_bonvoy`,

  // Derived roadmaps — Settings > Roadmap
  list_derived_roadmaps:
    domain + `method/ezy_flow.api.v1.derived_roadmap.list_derived_roadmaps`,
  create_derived_roadmap:
    domain + `method/ezy_flow.api.v1.derived_roadmap.create_derived_roadmap`,
  update_derived_roadmap:
    domain + `method/ezy_flow.api.v1.derived_roadmap.update_derived_roadmap`,
  workflow_enabled_doctypes:
    domain + `method/ezy_flow.api.v1.derived_roadmap.workflow_enabled_doctypes`,
  addDesignationroles:
    domain + `method/ezy_flow.api.v1.get_roles.get_role_list`,

  // Rules — the core rule engine. Reading and writing an Ezy Rule goes through
  // the generic resource APIs above (get_list, get_by_name, post_resource,
  // put_resource, converting_custom_api_delete_call); only what those cannot do
  // is listed here.
  rule_targets: domain + `method/ezy_flow.api.v1.rule_meta.get_rule_targets`,
  // A roadmap's rules and what each of its levels is tagged with, in one call.
  roadmap_rules: domain + `method/ezy_flow.api.v1.rule_levels.get_roadmap_rules`,
  rule_fields: domain + `method/ezy_flow.api.v1.rule_meta.get_rule_fields`,
  run_rules: domain + `method/ezy_flow.api.v1.rules.run_rules`,
  preview_rules: domain + `method/ezy_flow.api.v1.rules.preview_rules`,
  rule_matches: domain + `method/ezy_flow.api.v1.rules.rule_matches`,
  checking_requests_raised_for_workflow_to_delete_workflow: domain + `method/ezy_flow.ezy_flow.doctype.wf_roadmap.wf_roadmap.checking_requests_raised_for_workflow_to_delete_workflow`,
  check_login_password: domain + `method/ezy_flow.pwd_management.doctype.login_check.login_check.check_is_first_time_or_not`,
  confirm_login_password: domain + `method/ezy_flow.pwd_management.doctype.login_check.login_check.forgot_password_email_send`,
  otp_verification: domain + `method/ezy_flow.pwd_management.doctype.login_check.login_check.first_time_login_otp`,
  otp_validation: domain + `method/ezy_flow.pwd_management.doctype.login_check.login_check.otp_validation`,
  pwdEncryption: domain + `method/ezy_flow.pwd_management.doctype.pwd_encrypted_store.pwd_encrypted_store.storing_pwd_encrypted_code`,
  update_password: domain + `method/ezy_flow.pwd_management.doctype.login_check.login_check.update_password`,
  check_update_password: domain + `method/ezy_flow.pwd_management.doctype.login_check.login_check.update_is_first_value`,

};
